
import MColapsedPlayer from "./MColapsedPlayer";
import MExpandedPlayer from "./MExpandedPlayer";

import "./MSlidingPlayer.css";
import usePlayerControls from "../../hooks/usePlayerControls";

export default function MSlidingPlayer() {
  const {
    playerRef,
    listRef,
    height,
    progress,
    collapsedOpacity,
    expandedOpacity,
    transitioning,
    bottomOffset,
    onMouseDown,
    handleParentTap,
    wrapChildClick,
    onTabChevron,
    togglePlay,
  } = usePlayerControls({});

  return (
    <div
      ref={playerRef}
      className="sliding-player"
      style={{
        height: `${height}px`,
        transform: `translateY(-${bottomOffset}px)`,
        transition: transitioning ? "height 0.3s ease, transform 0.4s ease" : "none",
      }}
      onMouseDown={onMouseDown}
      onTouchStart={onMouseDown}
      onClick={handleParentTap}
    >
      {progress > 0.95 ? "" : <MColapsedPlayer
        wrapChildClick={wrapChildClick}
        togglePlay={togglePlay}
        onTabChevron={onTabChevron}
        collapsedOpacity={collapsedOpacity}
      />}
      {progress < 0.05 ? "" : <MExpandedPlayer
        wrapChildClick={wrapChildClick}
        onTabChevron={onTabChevron}
        expandedOpacity={expandedOpacity}
        listRef={listRef}
        togglePlay={togglePlay}
      />}
    </div>
  );
}
